import React, { useState } from "react";
import PyramidCard from "./PyramidCard";
import { Row, Col } from "react-bootstrap";
import { Button as DxButton } from "devextreme-react/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FeedbackForm from "./FeedbackForm";
import BugReportForm from "./BugReportForm";
import FeedbackDatagrid from "./FeedbackDatagrid";

const Feedback = () => {
  const [activeForm, setActiveForm] = useState(null);

  // TODO: Replace with actual data (API call ?) MATISSE
  const bugsInProgress = [
    {
      id: 1,
      title: "Image loading problem",
      status: "In Progress",
      priority: "High",
      dateReported: "2024-03-15",
      description: "The images do not load correctly on the home page",
    },
    {
      id: 2,
      title: "Intermittent connection error",
      status: "Resolved",
      priority: "Medium",
      dateReported: "2024-03-14",
      description: "The connection disconnects randomly",
    },
    {
      id: 3,
      title: "Performance issue",
      status: "In Progress",
      priority: "Low",
      dateReported: "2024-03-13",
      description: "The application is slow to respond",
    },
    {
      id: 4,
      title: "UI issue",
      status: "Resolved",
      priority: "High",
      dateReported: "2024-03-12",
      description: "The UI is not responsive",
    },
    {
      id: 5,
      title: "Data synchronization issue",
      status: "In Progress",
      priority: "Medium",
      dateReported: "2024-03-11",
      description: "The data does not synchronize correctly",
    },
    {
      id: 6,
      title: "Performance issue",
      status: "In Progress",
      priority: "Low",
      dateReported: "2024-03-10",
      description: "The application is slow to respond",
    },
    {
      id: 7,
      title: "Data synchronization issue",
      status: "Resolved",
      priority: "High",
      dateReported: "2024-03-09",
      description: "The data does not synchronize correctly",
    },
    {
      id: 8,
      title: "UI issue",
      status: "In Progress",
      priority: "Medium",
      dateReported: "2024-03-08",
      description: "The UI is not responsive",
    },
    {
      id: 9,
      title: "Performance issue",
      status: "In Progress",
      priority: "Low",
      dateReported: "2024-03-07",
      description: "The application is slow to respond",
    },
  ];

  const handleShowForm = (formType) => {
    setActiveForm(formType);
  };

  const handleCloseForm = () => {
    setActiveForm(null);
  };

  return (
    <>
      <PyramidCard title="Feedback">
        <div>
          {!activeForm ? (
            <div>
              <p className="mt-n2 mb-1">
                We appreciate your comments and suggestions. Please choose the
                type of feedback you want to send us.
              </p>

              <Row className="g-3">
                <Col md={6}>
                  <div className="border rounded p-4 h-100 d-flex flex-column">
                    <div className="text-center mb-3">
                      <div
                        className="bg-primary d-flex flex-center mx-auto rounded-circle shadow-sm"
                        style={{ height: "3.5rem", width: "3.5rem" }}
                      >
                        <FontAwesomeIcon
                          icon="star"
                          className="text-white fs-4"
                        />
                      </div>
                      <h5 className="mt-3">Evaluation and Suggestions</h5>
                    </div>
                    <p className="text-muted flex-grow-1">
                      Share your experience with our application and suggest
                      improvements.
                    </p>
                    <DxButton
                      type="default"
                      stylingMode="outlined"
                      className="w-100 mt-2"
                      onClick={() => handleShowForm("feedback")}
                    >
                      <FontAwesomeIcon icon="comment" className="me-2" />
                      Give my opinion
                    </DxButton>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="border rounded p-4 h-100 d-flex flex-column">
                    <div className="text-center mb-3">
                      <div
                        className="bg-danger d-flex flex-center mx-auto rounded-circle shadow-sm"
                        style={{ height: "3.5rem", width: "3.5rem" }}
                      >
                        <FontAwesomeIcon
                          icon="bug"
                          className="text-white fs-4"
                        />
                      </div>
                      <h5 className="mt-3">Bug Reporting</h5>
                    </div>
                    <p className="text-muted flex-grow-1">
                      Report a technical issue or a bug you have encountered in
                      the application.
                    </p>
                    <DxButton
                      type="danger"
                      stylingMode="outlined"
                      className="w-100 mt-2"
                      onClick={() => handleShowForm("bug")}
                    >
                      <FontAwesomeIcon
                        icon="exclamation-triangle"
                        className="me-2"
                      />
                      Report a bug
                    </DxButton>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <>
              {activeForm === "feedback" && (
                <FeedbackForm onClose={handleCloseForm} />
              )}
              {activeForm === "bug" && (
                <BugReportForm onClose={handleCloseForm} />
              )}
            </>
          )}
        </div>
      </PyramidCard>

      <FeedbackDatagrid bugsInProgress={bugsInProgress} />
    </>
  );
};

export default Feedback;
